import React, { useState } from 'react';
import Select, { components } from 'react-select';
import { Button, Card, CardBody, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';

import moment from 'moment';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import Variation from './variation';

const CustomSelectInput = props => {
    var customProps = Object.assign({}, props);
    delete customProps.autoCorrect;
    delete customProps.autoCapitalize;
    return <components.Input {...customProps} />;

};
const deviceWidth = () => {
    const width = window.innerWidth;
    const breakpoint = 820;
    return width < breakpoint ? 'mobile' : 'desktop';
}
// Time-based duration options (for window tint)
let options = []
let startDuration = '00:15';
for (let i = 0; i < 26; i++) {
    var obj = { label: startDuration, value: startDuration, key: i + 1 };
    startDuration = moment(startDuration, 'HH:mm').add('15', 'minutes').format('HH:mm');
    options.push(obj);
}

// Days-based duration options (for PPF)
let daysOptions = []
for (let j = 1; j <= 30; j++) {
    var dayLabel = j === 1 ? '1 Day' : `${j} Days`;
    daysOptions.push({ label: dayLabel, value: `${j}`, key: j });
}
const WindowTint = ({
    selectedWasher,
    allActiveServices,
    activeServices,
    variations,
    service,
    options,
    modifiers,
    update }) => {

    // Detect service type (PPF or Window Tint)
    const isPPF = service?.type?.toLowerCase() === 'ppf';
    const serviceType = isPPF ? 'PPF' : 'Window Tint';

    const [carType, setCarType] = useState({})
    const [addCarType, setAddCarType] = useState(false)
    const [editCarType, setEditCarType] = useState(false)

    const [editVariation, setEditVariation] = useState(false)
    const [addVariation, setAddVariation] = useState(false)
    const [addAvailableVariation, setAddAvailableVariation] = useState(false)
    const [selectedVariation, setSelectedVariation] = useState({})

    // Helper function to get available modifiers for the selected service
    const getAvailableModifiers = () => {
        if (!modifiers || !service) return [];

        // Get modifiers that are:
        // 1. Not already added to this service
        // 2. Included in the service's modifiers list
        const activeModifierKeys = Object.keys(activeServices?.[service?.key] || {});
        const serviceModifiers = service?.modifiers || [];

        return Object.values(modifiers).filter(item => {
            const isNotAdded = !activeModifierKeys.includes(item.key);
            const isInServiceModifiers = serviceModifiers.includes(item.key);
            return isNotAdded && isInServiceModifiers;
        });
    };
    let UpdateService = () => {
        if (!service?.key || !carType?.key) {
            console.warn('Cannot update service: missing service key or car type key');
            return;
        }

        // Initialize service in activeServices if it doesn't exist
        if (!activeServices[service.key]) {
            activeServices[service.key] = {};
        }

        // Update or add the car type (modifier) to the service
        // Works for both window tint and PPF services
        // Filter variations to only include those that match the service type
        const filteredVariations = (carType?.variations || []).filter(item => {
            const variation = variations?.[item];
            if (!variation) return false;

            // Filter by service type:
            // - Window tint: include variations with 'windowTint' type OR no type (legacy)
            // - PPF: include only variations with 'ppf' type
            if (isPPF) {
                return variation.variationType === 'ppf';
            } else {
                return !variation.variationType || variation.variationType === 'windowTint';
            }
        });

        activeServices[service.key][carType.key] = {
            price: "0",
            duration: carType?.duration || (isPPF ? '1' : '00:15'), // Default to 1 day for PPF, 00:15 for window tint
            capacity: carType?.capacity || '', // Capacity limit for the category
            variations: filteredVariations
        }

        // Reset state
        setCarType({})
        setAddCarType(false)
        setEditCarType(false)

        // Notify parent component of the update with a new object reference
        update({ activeServices: { ...activeServices } })
    }

    return (
        <Row className='h-100' style={{ height: '100%', margin: 0 }}>
            <Colxx xxs="12" md="12" style={{ height: '100%', display: 'flex', padding: 0 }}>
                <Card className="rounded h-100" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)', width: '100%', display: 'flex', flexDirection: 'column' }}>
                    <CardBody style={{ padding: '25px', flex: 1, overflowY: 'auto' }}>
                        <div className="d-flex justify-content-between align-items-center mb-4" style={{
                            paddingBottom: '15px',
                            borderBottom: '1px solid #e9ecef'
                        }}>
                            <div>
                                <h2 className="mb-1" style={{
                                    fontWeight: '600',
                                    color: '#2c3e50',
                                    fontSize: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px'
                                }}>
                                    <i className="simple-icon-energy" style={{ color: '#3498db', fontSize: '22px' }}></i>
                                    {service?.type?.toLowerCase() === 'ppf' ? 'PPF Service' : 'Window Tint Service'}
                                </h2>
                                <p className="text-muted mb-0" style={{ fontSize: '13px', marginTop: '4px' }}>
                                    {service?.type?.toLowerCase() === 'ppf'
                                        ? 'Configure PPF service for different vehicle types'
                                        : 'Configure window tint service for different vehicle types'}
                                </p>
                            </div>
                        </div>

                        <div style={{ marginBottom: '20px' }}>
                            <Label style={{ fontWeight: '600', color: '#2c3e50', fontSize: '14px', marginBottom: '10px', display: 'block' }}>
                                <i className="simple-icon-plus" style={{ marginRight: '8px', color: '#3498db' }}></i>
                                Add Vehicle Types
                            </Label>
                            <Select
                                components={{ Input: CustomSelectInput }}
                                className="react-select"
                                placeholder={
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <i className="simple-icon-plus" style={{ fontSize: '14px' }}></i>
                                        <span>Add Vehicle Types</span>
                                    </div>
                                }
                                name="form-field-name"
                                options={getAvailableModifiers()}
                                isDisabled={!service?.key || !service?.modifiers || service?.modifiers?.length === 0}
                                onChange={(e) => {
                                    if (e) {
                                        setCarType(e)
                                        setAddCarType(true)
                                    }
                                }}
                            />
                            {(!service?.modifiers || service?.modifiers?.length === 0) && (
                                <p style={{ fontSize: '12px', color: '#ff9800', marginTop: '8px', marginBottom: 0 }}>
                                    <i className="simple-icon-exclamation" style={{ marginRight: '4px' }}></i>
                                    No vehicle types available. Please configure modifiers for this {serviceType.toLowerCase()} service.
                                </p>
                            )}
                        </div>

                        {allActiveServices && allActiveServices.length ? (
                            <Table borderless style={{
                                background: '#fff',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                border: '1px solid #e9ecef'
                            }}>
                                <thead style={{ background: '#f8f9fa' }}>
                                    <tr>
                                        <th style={{
                                            padding: '12px 15px',
                                            fontWeight: '600',
                                            color: '#2c3e50',
                                            fontSize: '14px',
                                            borderBottom: '2px solid #e9ecef'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="simple-icon-tag" style={{ color: '#3498db', fontSize: '16px' }}></i>
                                                <span>Name</span>
                                            </div>
                                        </th>
                                        {deviceWidth() === 'desktop' && (
                                            <th style={{
                                                padding: '12px 15px',
                                                fontWeight: '600',
                                                color: '#2c3e50',
                                                fontSize: '14px',
                                                borderBottom: '2px solid #e9ecef'
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <i className="simple-icon-clock" style={{ color: '#e74c3c', fontSize: '16px' }}></i>
                                                    <span>Duration</span>
                                                </div>
                                            </th>
                                        )}
                                        <th style={{
                                            padding: '12px 15px',
                                            fontWeight: '600',
                                            color: '#2c3e50',
                                            fontSize: '14px',
                                            borderBottom: '2px solid #e9ecef',
                                            textAlign: 'center'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                <i className="simple-icon-layers" style={{ color: '#27ae60', fontSize: '16px' }}></i>
                                                <span>Variations</span>
                                            </div>
                                        </th>
                                        <th style={{
                                            width: '60px',
                                            borderBottom: '2px solid #e9ecef',
                                            textAlign: 'center'
                                        }}>
                                            {/* <i className="simple-icon-trash" style={{ color: '#dc3545', fontSize: '16px' }}></i> */}
                                        </th>
                                        <th style={{
                                            width: '80px',
                                            borderBottom: '2px solid #e9ecef',
                                            textAlign: 'center'
                                        }}>
                                            {/* <i className="simple-icon-pencil" style={{ color: '#3498db', fontSize: '16px' }}></i> */}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allActiveServices.filter(item => item && item.key).map((item, index) => {
                                        const filteredItems = allActiveServices.filter(i => i && i.key);
                                        return (
                                            <tr
                                                key={item.key || index}
                                                style={{
                                                    borderBottom: index < filteredItems.length - 1 ? '1px solid #f0f0f0' : 'none',
                                                    transition: 'all 0.15s ease'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = '#f8f9fa';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = '#fff';
                                                }}
                                            >
                                                <td style={{ padding: '15px', verticalAlign: 'middle' }}>
                                                    <div style={{ fontSize: '14px', color: '#2c3e50' }}>
                                                        {item?.name || ''}
                                                    </div>
                                                </td>
                                                {deviceWidth() === 'desktop' && (
                                                    <td style={{ padding: '15px', verticalAlign: 'middle' }}>
                                                        <div style={{ fontSize: '14px', color: '#2c3e50' }}>
                                                            {item?.duration || ''}
                                                        </div>
                                                    </td>
                                                )}
                                                <td style={{ padding: '15px', verticalAlign: 'middle', textAlign: 'center' }}>
                                                    {(() => {
                                                        const variationsCount = (service?.key && item?.key && activeServices[service.key]?.[item.key]?.variations?.length) || 0;
                                                        return (
                                                            <div style={{
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                padding: '6px 12px',
                                                                borderRadius: '6px',
                                                                background: variationsCount > 0 ? '#e8f5e9' : '#f5f5f5',
                                                                color: variationsCount > 0 ? '#27ae60' : '#6c757d',
                                                                fontWeight: '600',
                                                                fontSize: '14px',
                                                                minWidth: '50px'
                                                            }}>
                                                                <i className="simple-icon-layers" style={{
                                                                    fontSize: '14px',
                                                                    marginRight: '6px',
                                                                    color: variationsCount > 0 ? '#27ae60' : '#6c757d'
                                                                }}></i>
                                                                {variationsCount} {variationsCount === 1 ? 'variation' : 'variations'}
                                                            </div>
                                                        );
                                                    })()}
                                                </td>
                                                <td style={{ padding: '0', verticalAlign: 'middle', textAlign: 'center' }}>
                                                    <Button
                                                        color="danger"
                                                        size="sm"
                                                        outline
                                                        className="top-right-button"
                                                        onClick={() => {
                                                            if (!service?.key || !item?.key) return;
                                                            if (Object.keys(activeServices[service.key] || {}).length > 1) {
                                                                delete activeServices[service.key][item.key];
                                                            } else {
                                                                delete activeServices[service.key];
                                                            }
                                                            update({ activeServices });
                                                        }}
                                                        style={{
                                                            borderRadius: '6px',
                                                            fontWeight: '500',
                                                            padding: '6px 12px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            transition: 'all 0.15s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(-1px)';
                                                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(220, 53, 69, 0.2)';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                            e.currentTarget.style.boxShadow = 'none';
                                                        }}
                                                    >
                                                        <i className="simple-icon-trash" style={{ fontSize: '12px' }}></i>
                                                        Remove
                                                    </Button>
                                                </td>
                                                <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>
                                                    <Button
                                                        color="primary"
                                                        size="sm"
                                                        outline
                                                        className="top-right-button"
                                                        onClick={() => {
                                                            if (!item) return;
                                                            setEditCarType(true)
                                                            setCarType(item)
                                                        }}
                                                        style={{
                                                            borderRadius: '6px',
                                                            fontWeight: '500',
                                                            padding: '6px 12px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            transition: 'all 0.15s ease'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(-1px)';
                                                            e.currentTarget.style.boxShadow = '0 2px 4px rgba(52, 152, 219, 0.2)';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                            e.currentTarget.style.boxShadow = 'none';
                                                        }}
                                                    >
                                                        <i className="simple-icon-pencil" style={{ fontSize: '12px' }}></i>
                                                        Edit
                                                    </Button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        ) : (
                            <div className="text-center text-muted mt-4" style={{ padding: '40px 20px' }}>
                                <i className="simple-icon-energy" style={{ fontSize: '48px', color: '#e0e0e0', marginBottom: '15px', display: 'block' }}></i>
                                <p style={{ fontSize: '14px', fontWeight: '500', marginBottom: '5px' }}>No vehicle types selected</p>
                                <p style={{ fontSize: '12px', color: '#999' }}>Use the dropdown above to add vehicle types</p>
                            </div>
                        )}
                    </CardBody>
                </Card>
            </Colxx>

            <Modal
                size='lg'
                isOpen={addCarType || editCarType}
                backdrop="static"
                // centered
                className="modal-shadow"
            >
                <ModalHeader style={{ borderBottom: '1px solid #e9ecef', padding: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <i className="simple-icon-settings" style={{ color: '#3498db', fontSize: '20px' }}></i>
                        <span style={{ fontWeight: '600', color: '#2c3e50' }}>
                            {editCarType ? 'Edit' : 'Add'} Vehicle Type
                        </span>
                    </div>
                </ModalHeader>
                <ModalBody style={{ padding: '25px' }}>
                    <Row className="d-flex align-items-center mb-4" style={{
                        paddingBottom: '15px',
                        borderBottom: '1px solid #e9ecef'
                    }}>
                        <Colxx xxs="12" md="6">
                            <h2 style={{
                                fontWeight: '600',
                                color: '#2c3e50',
                                fontSize: '20px',
                                margin: 0,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <i className="simple-icon-car" style={{ color: '#3498db', fontSize: '18px' }}></i>
                                {carType?.name}
                            </h2>
                        </Colxx>
                    </Row>
                    <Row>
                        <Colxx xxs="6" className="mt-2">
                            <Label style={{ fontWeight: '600', color: '#2c3e50', fontSize: '14px', marginBottom: '10px', display: 'block' }}>
                                <i className="simple-icon-clock" style={{ marginRight: '8px', color: '#3498db', fontSize: '12px' }}></i>
                                Default Duration
                            </Label>
                            <Select
                                components={{ Input: CustomSelectInput }}
                                className="react-select"
                                name="form-field-name"
                                value={carType?.duration ? (isPPF ? { value: carType?.duration, label: carType?.duration === '1' ? '1 Day' : `${carType?.duration} Days`, key: carType?.duration } : { value: carType?.duration, label: carType?.duration, key: carType?.duration }) : ''}
                                placeholder={isPPF ? "e.g. 1 Day" : "e.g. 00:15"}
                                onChange={(e) => {
                                    let newDuration = JSON.parse(JSON.stringify(carType))
                                    newDuration.duration = e.value
                                    setCarType(newDuration)
                                }}
                                options={isPPF ? daysOptions : options}
                            />
                        </Colxx>
                        <Colxx xxs="6" className="mt-2">
                            <Label style={{ fontWeight: '600', color: '#2c3e50', fontSize: '14px', marginBottom: '10px', display: 'block' }}>
                                <i className="simple-icon-user" style={{ marginRight: '8px', color: '#3498db', fontSize: '12px' }}></i>
                                Capacity Limit
                                <span style={{ color: '#6c757d', fontWeight: '400', fontSize: '12px', marginLeft: '6px' }}>(Optional)</span>
                            </Label>
                            <Input
                                className="customInput"
                                type="number"
                                min="1"
                                value={carType?.capacity || ''}
                                placeholder="e.g. 5"
                                onChange={(e) => {
                                    let newCapacity = JSON.parse(JSON.stringify(carType))
                                    newCapacity.capacity = e.target.value
                                    setCarType(newCapacity)
                                }}
                            />
                        </Colxx>
                    </Row >


                    <Row>
                        <Colxx xxs="12" className="mt-4" >
                            <Label style={{ fontWeight: '600', color: '#2c3e50', fontSize: '14px', marginBottom: '10px', display: 'block' }}>
                                <i className="simple-icon-layers" style={{ marginRight: '8px', color: '#3498db' }}></i>
                                Variations
                            </Label>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', marginBottom: '15px' }}>
                                <div style={{
                                    flex: '1'
                                }}>
                                    <Select
                                        components={{ Input: CustomSelectInput }}
                                        className="react-select"
                                        placeholder={
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="simple-icon-list" style={{ fontSize: '14px' }}></i>
                                                <span>Select Variations</span>
                                            </div>
                                        }
                                        name="form-field-name"
                                        options={variations && Object.values(variations).filter(item => {
                                            // Filter variations based on:
                                            // 1. Not already added to this car type
                                            // 2. Belongs to the selected washer
                                            // 3. Matches the service type (PPF or window tint)
                                            //    - Window tint: show variations with 'windowTint' type OR no type (legacy)
                                            //    - PPF: show only variations with 'ppf' type
                                            const isNotAdded = !carType?.variations?.includes(item.key);
                                            const isWorkerVariation = item.worker_id === selectedWasher.key;

                                            let matchesServiceType = false;
                                            if (isPPF) {
                                                // PPF services: only show variations with 'ppf' type
                                                matchesServiceType = item.variationType === 'ppf';
                                            } else {
                                                // Window tint services: show variations with 'windowTint' type OR no type (legacy/backward compatibility)
                                                matchesServiceType = !item.variationType || item.variationType === 'windowTint';
                                            }

                                            return isNotAdded && isWorkerVariation && matchesServiceType;
                                        })}
                                        onChange={(e) => {
                                            setSelectedVariation({ ...variations[e.key], key: e.key })
                                            setEditVariation(true)
                                            setAddAvailableVariation(true)
                                        }}
                                    />
                                </div>

                                <Button
                                    color="primary"
                                    onClick={() => {
                                        setAddVariation(true)
                                    }}
                                    style={{
                                        borderRadius: '6px',
                                        fontWeight: '500',
                                        padding: '8px 16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    <i className="simple-icon-plus" style={{ fontSize: '12px' }}></i>
                                    Add New
                                </Button>
                            </div>
                            {
                                carType?.variations?.filter(item => {
                                    // Only show variations that exist and match the service type
                                    const variation = variations?.[item];
                                    if (!variation) return false;

                                    // Filter by service type:
                                    // - Window tint: show variations with 'windowTint' type OR no type (legacy)
                                    // - PPF: show only variations with 'ppf' type
                                    if (isPPF) {
                                        return variation.variationType === 'ppf';
                                    } else {
                                        return !variation.variationType || variation.variationType === 'windowTint';
                                    }
                                })?.map((item, index) => {
                                    return (
                                        <Card key={index} className="mt-3 rounded" style={{
                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                            border: '1px solid #e0e0e0',
                                            transition: 'all 0.15s ease'
                                        }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
                                                e.currentTarget.style.borderColor = '#d0d0d0';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                                                e.currentTarget.style.borderColor = '#e0e0e0';
                                            }}
                                        >
                                            <CardBody className='pr-4 pl-4 pb-3 pt-3'>
                                                <Row className="d-flex align-items-center">
                                                    <Colxx xxs="6">
                                                        <div style={{
                                                            fontSize: '15px',
                                                            fontWeight: '500',
                                                            color: '#2c3e50',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px'
                                                        }}>
                                                            <i className="simple-icon-layers" style={{ color: '#3498db', fontSize: '14px' }}></i>
                                                            {variations?.[item]?.name}
                                                        </div>
                                                    </Colxx>
                                                    <Colxx xxs="6" className="d-flex" style={{ justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
                                                        <div style={{
                                                            fontSize: '16px',
                                                            color: '#dc3545',
                                                            cursor: 'pointer',
                                                            padding: '6px',
                                                            borderRadius: '4px',
                                                            transition: 'all 0.15s ease',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.background = '#fee';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.background = 'transparent';
                                                            }}
                                                            onClick={() => {
                                                                let newCarType = JSON.parse(JSON.stringify(carType))
                                                                newCarType.variations = newCarType.variations.filter(rec => rec !== item)
                                                                setCarType(newCarType)
                                                            }}
                                                            title="Remove variation"
                                                        >
                                                            <i className="simple-icon-close" />
                                                        </div>
                                                        <div style={{
                                                            fontSize: '16px',
                                                            color: '#3498db',
                                                            cursor: 'pointer',
                                                            padding: '6px',
                                                            borderRadius: '4px',
                                                            transition: 'all 0.15s ease',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                            onMouseEnter={(e) => {
                                                                e.currentTarget.style.background = '#e3f2fd';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.currentTarget.style.background = 'transparent';
                                                            }}
                                                            onClick={() => {
                                                                setSelectedVariation({ ...variations[item], key: item })
                                                                setEditVariation(true)
                                                            }}
                                                            title="Edit variation"
                                                        >
                                                            <i className="simple-icon-pencil" />
                                                        </div>
                                                    </Colxx>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    )
                                })
                            }
                        </Colxx>
                    </Row>
                </ModalBody>
                <ModalFooter style={{ borderTop: '1px solid #e9ecef', padding: '15px 20px' }}>
                    <Button
                        color="secondary"
                        outline
                        onClick={() => {
                            setEditCarType(false)
                            setAddCarType(false)
                        }}
                        style={{ borderRadius: '6px', fontWeight: '500', padding: '8px 20px' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="primary"
                        onClick={() => UpdateService()}
                        style={{ borderRadius: '6px', fontWeight: '500', padding: '8px 20px', display: 'flex', alignItems: 'center', gap: '6px' }}
                    >
                        <i className="simple-icon-check" style={{ fontSize: '12px' }}></i>
                        {editCarType ? 'Save Service' : 'Add Service'}
                    </Button>
                </ModalFooter>
            </Modal>
            {(addVariation || editVariation) && <Variation
                service={service}
                carType={carType?.name}
                carKey={carType?.key}
                selectedWasher={selectedWasher}
                addVariation={addVariation}
                editVariation={editVariation}
                selectedVariation={selectedVariation}
                dismiss={(e) => {
                    if (addVariation && e) {
                        let newCarType = JSON.parse(JSON.stringify(carType))
                        newCarType.variations = newCarType?.variations || []
                        newCarType.variations.push(e)
                        setCarType(newCarType)
                    }
                    setAddAvailableVariation(false)
                    setSelectedVariation({})
                    setEditVariation(false)
                    setAddVariation(false)
                }}
                availableVariation={addAvailableVariation}
                addAvailableVariation={() => {
                    if (addAvailableVariation) {
                        let newCarType = JSON.parse(JSON.stringify(carType))
                        newCarType.variations = newCarType?.variations || []
                        newCarType.variations.push(selectedVariation.key)
                        setCarType(newCarType)
                    }
                    setSelectedVariation({})
                    setAddAvailableVariation(false)
                    setEditVariation(false)
                    setAddVariation(false)
                }}
            />}
        </Row>
    );
};

export default WindowTint;